import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { CheckCircle2, FileCheck2, CalendarDays, GraduationCap, LayoutDashboard, ShieldCheck, BarChart3, QrCode } from "lucide-react";

const heroIcons = {
  resources: FileCheck2,
  events: CalendarDays,
  lms: GraduationCap,
  "client-portal": LayoutDashboard,
  admin: ShieldCheck,
  analytics: BarChart3,
  certificate: QrCode,
};

export default function DetailHero({ config, page }) {
  const Icon = heroIcons[page] || ShieldCheck;

  return (
    <Box
      component="section"
      sx={{
        position: "relative", overflow: "hidden",
        bgcolor: "white", py: 14,
      }}
    >
      <Box className="tech-grid" sx={{ position: "absolute", inset: 0, opacity: 0.20, pointerEvents: "none" }} />
      <Box sx={{
        position: "absolute", inset: 0, pointerEvents: "none",
        background: "radial-gradient(circle at 22% 18%, rgba(10,132,255,0.28), transparent 34%), radial-gradient(circle at 80% 24%, rgba(94,92,230,0.18), transparent 34%)",
      }} />

      <Box sx={{ maxWidth: 1280, mx: "auto", px: { xs: 2, md: 4 }, position: "relative" }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Typography variant="overline" sx={{ fontWeight: 700, letterSpacing: "0.2em", color: "text.secondary", display: "block", mb: 1 }}>
              {config.eyebrow}
            </Typography>
            <Typography variant="h2" fontWeight={700} sx={{ fontSize: { xs: "2rem", md: "3rem" }, lineHeight: 1.1, mb: 2 }}>
              {config.title}
            </Typography>
            <Typography variant="body1" color="text.secondary" lineHeight={1.8}>
              {config.copy}
            </Typography>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Box sx={{
              border: "1px solid rgba(0,0,0,0.08)", borderRadius: 4,
              bgcolor: "rgba(255,255,255,0.6)", p: 4, backdropFilter: "blur(12px)",
            }}>
              <Icon size={48} color="#2A8DFF" />
              <Grid container spacing={1.5} sx={{ mt: 3 }}>
                {config.features?.map((feature) => (
                  <Grid item xs={12} sm={6} key={feature}>
                    <Box sx={{ bgcolor: "rgba(42,141,255,0.06)", borderRadius: 2.5, p: 2 }}>
                      <CheckCircle2 size={18} color="#22C55E" style={{ marginBottom: 8 }} />
                      <Typography variant="body2" fontWeight={600}>{feature}</Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}